import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import SideList from "../../../UI-component/SideList";
import ErrorAlert from "../../../UI-component/ErrorAlert";
import CustomerFormBox from "../../../UI-component/registryForms/CustomerFormBox";
import NextBtnForm from "../../../UI-component/NexBtnForm";
import SuccessfullPopup from "../../../UI-component/SuccessfullPopup";
import Loader from "../../../UI-component/Loader";
import { useAccess } from "./access";

function General(props) {
  const isStopped = useSelector(state => state.stepSlice.data.stopped);

  const {data, values, loading, error, isValidStep, update, updateField, save, savePrefs} = useAccess(props.save);

  const onNext = () => {
    props.next();
  }

  return (
    <div className="row">
      <SideList
        infoList={[
          { element: "Richiedente", id: "#report-author" },
          ...(data?.richiedente?.[0]?.type?.type === "Delegato" ? [
            { element: "Delegante", id: "#report-author" },
          ] : [])
        ]} />

      <div className="col-12 col-lg-8 offset-lg-1">
        <div className="steppers-content" aria-live="polite">
          <div className="it-page-sections-container">

            {
              <ErrorAlert errors={[{ name: "Richiedente", id: "#isee-info" }]} err={error?.richiedente || isStopped} />
            }
            <Loader loading={loading} fixedPosition/>

            <CustomerFormBox id="richiedente"
              cards={data?.richiedente?.length > 0 ? [data?.richiedente] : []}
              type={values?.customer_types ? true : false}
              typeData={values?.customer_types ? data?.richiedente?.[0]?.type?.type : null}
              types={values?.customer_types || null}
              description="Informazione su di te"
              title="Richiedente"
              service={props.info.code}
              update={update}
              prefData={props.info.data?.richiedente}
            />

            {(values?.customer_types && (data?.richiedente?.[0]?.type?.type === "Delegato" || data?.delegato?.length > 0)) &&
              <CustomerFormBox id="delegato"
                cards={data?.delegato?.length > 0 ? [data?.delegato] : []}
                type={false}
                description="Informazioni sulla persona delegata, da compilare solo nel caso in cui il richiedente non sia il delegato stesso"
                title="Delegato"
                customTitle="Delegante"
                service={props.info.code}
                update={update}
              />
            }
          </div>
        </div>
        <NextBtnForm
          next={onNext}
          back={props.back}
          saveRequest={save}
          disabled={!isValidStep("general")} />

        {
          props.saved &&
          <SuccessfullPopup />
        }

        {
          props.fail &&
          <SuccessfullPopup isError={true} />
        }
      </div>
    </div>
  )
}


export default General;